module.exports = __webpack_public_path__ + "static/media/dash_logo.8b98770b.png";